import React from "react";
import styles from "./KnowledgeSeries.module.css";
import Counter from "../../components/CountDown/CountDown";
import { useNavigate } from "react-router-dom";
import { useApi } from "../../hooks/useApi";
import { API_ENDPOINTS } from "../../api/endpoints";
import { KnowledgeSeriesData, counterData } from "../../utils/dummyData";
import Loader from "../../components/Loader/Loader";
import ErrorMsg from "../../components/ErrorMsg/ErrorMsg";

export default function KnowledgeSeries(props) {
  const {
    response: knowledgeSeriesData,
    loading: loadingKnowledge,
    error: errorKnowledge,
  } = useApi(API_ENDPOINTS.HOME_KNOWLEDGE_SERIES);
  const {
    response: countData,
    loading: loadingCount,
    error: errorCount,
  } = useApi(API_ENDPOINTS.HOME_COUNTERS);
  const apiData = knowledgeSeriesData?.knowledgeSeries ?? KnowledgeSeriesData;
  const counterDataAPI = countData?.counters ?? counterData;
  const navigate = useNavigate();

  return (
    <section className={styles.knowledge}>
      <div className={styles.container}>
        <h3>
          Knowledge <span>Series</span>
        </h3>
        <div className={styles.cards}>
          {loadingKnowledge ? (
            <Loader />
          ) : errorKnowledge ? (
            <ErrorMsg message={"Failed to load Data."} />
          ) : (
            apiData.map((item) => (
              <div className={styles.card} key={item.id}>
                <div className={styles.innerWhite}>
                  <time>{item.date_range}</time>
                  <h4>{item.title}</h4>
                  <button onClick={() => navigate(item.link)}>
                    {item.button_name}
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
        <div className={styles.countOuter}>
          {loadingCount ? (
            <Loader />
          ) : errorCount ? (
            <ErrorMsg />
          ) : (
            Object.entries(counterDataAPI || {}).map(
              ([description, value], index) => (
                <Counter
                  key={description}
                  end={parseInt(String(value ?? ""), 10) || 0}
                  duration={1500}
                  showPlus={String(value ?? "").includes("+")}
                  description={description}
                  styleName={`count${index + 1}`}
                />
              )
            )
          )}
        </div>
      </div>
    </section>
  );
}
